<template>
  <div>
    <template v-if="isApplicationLoading || isApplicationTemplateLoading">
      <Loading />
    </template>

    <template v-else>
      <template v-if="getCurrentApplicationTemplate">
        <ApplySubNav
          active="pay"
          :verify="getCurrentApplicationTemplate.need_applicant_experian_authtoken"
          :pay="getCurrentApplicationTemplate.price > 0"
          :income="getCurrentApplicationTemplate.need_applicant_finicity_bank_connection"
        />
      </template>
      <template v-if="getCurrentApplication">
        <div class="h-full bg-brand-light-gray py-5" style="min-height: 95vh">
          <div class="max-w-screen-md mx-auto">
            <SectionContainer>
              <img class="m-auto py-5" src="@/assets/icons/bellhop.svg" />

              <div class="py-5 px-5">
                <p class="py-2">
                  We all know the headaches of moving. Changing your address on 50 million websites.
                  Telling all your friends. Haggling over your security deposit. But by far the
                  worst part is physically moving your belongings. You're faced with a tough choice.
                  On the one side is lugging all of your furniture and boxes yourself. On the other
                  side is a slimy moving company who hasn't gotten a 5-star review in their life.
                </p>

                <p class="py-2">
                  Luckily, that's not a choice you need to make anymore. Because our partner Bellhop
                  has fixed it. Bellhop is a nationwide moving service powered by state-of-the-art
                  tech and customer service. They've accomplished a 4.8/5 star rating -- virtually
                  unheard of in the moving industry.
                </p>

                <p class="py-2">
                  And they've agreed to give all of our applicants a 5% discount on their move!
                  Would you like them to reach out to give you some more info?
                </p>
              </div>

              <div class="flex items-center w-2/3 mx-auto mb-5">
                <div class="flex items-center py-1">
                  <input
                    id="optin"
                    type="checkbox"
                    class="w-5 h-5 rounded border-gray-300 text-brand-green focus:ring-brand-green"
                    v-model="optin"
                  />
                  <label for="optin" class="ml-4 block text-brand-black"
                    >Yes! I want to save time and money on my move. <br />Have Bellhop send me more
                    info.</label
                  >
                </div>
              </div>

              <div class="md:w-1/3 md:mx-auto py-3">
                <PrimaryButton @click="next">Continue</PrimaryButton>
              </div>
            </SectionContainer>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

import { APPLICATION_GET, APPLICATION_UPDATE } from "@/store/types"

export default {
  components: {},
  computed: {
    ...mapGetters([
      "isApplicationTemplateLoading",
      "getCurrentApplicationTemplate",
      "isApplicationLoading",
      "getCurrentApplication"
    ])
  },

  async mounted() {
    if (!this.isApplicationLoading && !this.getCurrentApplication) {
      const id = this.$route.params.id
      await this.$store.dispatch(APPLICATION_GET, { id })
    }

    this.hasIdentity = !!this.getCurrentApplication.reports.find(
      (r) => r.identifier.includes("mvga_identity")
    )

    if (this.$parent.$parent.editing) {
      this.editing = this.$parent.$parent.editing
    }
  },
  data() {
    return {
      optin: true
    }
  },
  methods: {
    async next() {
      const id = this.$route.params.id

      if (this.optin) {
        await this.$store.dispatch(APPLICATION_UPDATE, {
          id,
          data: { affiliate_offer_optin: true }
        })
      }

      this.$router.push({ name: "apply_complete", params: { id } })
    }
  }
}
</script>
